import { render, staticRenderFns } from "./OrphanLinksTab.vue?vue&type=template&id=0743d843&scoped=true"
import script from "./OrphanLinksTab.vue?vue&type=script&lang=js"
export * from "./OrphanLinksTab.vue?vue&type=script&lang=js"
import style0 from "./OrphanLinksTab.vue?vue&type=style&index=0&id=0743d843&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0743d843",
  null
  
)

export default component.exports